import { render, staticRenderFns } from "./AccesControlDetailStatic.vue?vue&type=template&id=1c576ad0"
import script from "./AccesControlDetailStatic.vue?vue&type=script&lang=js"
export * from "./AccesControlDetailStatic.vue?vue&type=script&lang=js"
import style0 from "./AccesControlDetailStatic.vue?vue&type=style&index=0&id=1c576ad0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports